import React, { useState, useEffect } from 'react';
import PropdocsModal from '../../../components/modal/PropdocsModal';
import { Button, Form } from 'react-bootstrap';

interface TextInputModalProps {
  isOpen: boolean;
  fieldType: string;
  initialValue?: string;
  onComplete: (text: string) => void;
  onClose: () => void;
}

export const TextInputModal: React.FC<TextInputModalProps> = ({
  isOpen,
  fieldType,
  initialValue = '',
  onComplete,
  onClose
}) => {
  const [text, setText] = useState(initialValue);

  useEffect(() => {
    setText(initialValue);
  }, [initialValue, isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (text.trim()) {
      onComplete(text.trim());
      onClose(); // Ensure modal closes after completion
    }
  };

  const handleCancel = () => {
    setText(initialValue);
    onClose();
  };

  return (
    <PropdocsModal
      show={isOpen}
      setShow={handleCancel}
      size="md"
      title={<span>Enter Text</span>}
    >
      <Form onSubmit={handleSubmit}>
        <div style={{ padding: '1rem 0' }}>
          <Form.Group>
            <Form.Label>Text Field Value</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Enter text..."
              autoFocus
              maxLength={1000}
              style={{ resize: 'vertical' }}
            />
          </Form.Group>
        </div>

        <div style={{ marginTop: '1.5rem', display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
          <Button variant="outline-secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={!text.trim()}
          >
            Apply
          </Button>
        </div>
      </Form>
    </PropdocsModal>
  );
};
